import { useEffect } from "react";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import WhatsAppButton from "@/components/WhatsAppButton";

export default function PageShell({ children, testid }) {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div data-testid={testid}>
      <Header solid />
      <main className="pt-20">{children}</main>
      <Footer />
      <WhatsAppButton />
    </div>
  );
}
